import at from "lodash/at";
import { useField } from "formik";
import {
  FilledInputProps,
  InputBaseComponentProps,
  InputLabelProps,
  InputProps,
  OutlinedInputProps,
  SxProps,
  TextField,
  Theme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { KeyboardEventHandler } from "react";

type InputFieldProps = {
  placeholder?: string;
  label: string;
  name: string;
  disabled?: boolean;
  sx?: SxProps<Theme> | undefined;
  valueProp?: unknown;
  InputLabelProps?: Partial<InputLabelProps>;
  InputProps?:
    | Partial<FilledInputProps>
    | Partial<OutlinedInputProps>
    | Partial<InputProps>;
  onKeyDown?: KeyboardEventHandler<HTMLDivElement>;
  multiline?: boolean;
  rows?: number;
  inputProps?: InputBaseComponentProps;
};

export default function InputField({
  placeholder,
  label,
  disabled,
  InputLabelProps,
  InputProps,
  multiline,
  name,
  onKeyDown,
  sx,
  rows,
  inputProps,
}: InputFieldProps) {
  const [field, meta] = useField(name);
  const { t } = useTranslation();
  const [touched, error] = at(meta, "touched", "error");
  const isError = touched && error && true;

  return (
    <TextField
      rows={rows}
      multiline={multiline}
      onKeyDown={onKeyDown}
      sx={sx}
      inputProps={inputProps}
      InputLabelProps={InputLabelProps}
      InputProps={InputProps}
      type="text"
      disabled={disabled}
      fullWidth
      label={t(label)}
      placeholder={t(placeholder ?? "")}
      error={isError}
      helperText={isError ? t(error) : ""}
      {...field}
    />
  );
}
